import { createWithEqualityFn } from "zustand/traditional";

import type { UserSegmentationData } from "@medbillai/generated-graphql-types";

export type { UserSegmentationData };

interface StoreState {
  isSignUpOnboarding: boolean;
  userSegmentationData: UserSegmentationData;
  shouldShowReferralModal: boolean;
}

const initialState: StoreState = {
  isSignUpOnboarding: false,
  userSegmentationData: {
    useCases: undefined,
    usageScopes: undefined,
    features: undefined,
  },
  shouldShowReferralModal: false,
};

type Action = {
  setUserSegmentationData: (data: Partial<UserSegmentationData>) => void;
  setIsSignUpOnboarding: (isSignUpOnboarding: boolean) => void;
  setShouldShowReferralModal: (shouldShow: boolean) => void;
  reset: () => void;
};

export const useSignUpOnboardingStore = createWithEqualityFn<
  StoreState & Action
>(set => ({
  ...initialState,
  setUserSegmentationData: data =>
    set(state => ({
      userSegmentationData: {
        ...state.userSegmentationData,
        ...data,
      },
    })),
  setIsSignUpOnboarding: isSignUpOnboarding =>
    set({
      isSignUpOnboarding,
    }),
  setShouldShowReferralModal: shouldShowReferralModal =>
    set({
      shouldShowReferralModal,
    }),
  // We call reset after calling sendMagicLink so we do not upsert data twice.
  // We do not want to clear the isSignUpOnboarding state because we use it to
  // render the onboarding screen. This will be cleared regardless when the user
  // authenticates the magic link email address.
  // We also preserve shouldShowReferralModal because it's set during authentication.
  reset: () =>
    set(state => ({
      ...initialState,
      isSignUpOnboarding: state.isSignUpOnboarding,
      shouldShowReferralModal: state.shouldShowReferralModal,
    })),
}));
